'use client';

import { Icon } from '@eliadmin/core/src/components/dlz/ui/icon';
import { Input } from '@eliadmin/core/src/components/ui/input';

/**
 * Figma „Search“ of the store list and the FAQ: 46 px field (radius 18, phone 14), magnifier 20 px on
 * the left, placeholder in text/disabled. Filters the list below it as the user types.
 */
export function SearchField({
  label,
  value,
  onChange,
}: {
  /** Placeholder and accessible name. */
  label: string;
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <Input
      type="search"
      value={value}
      onChange={event => onChange(event.target.value)}
      placeholder={label}
      aria-label={label}
      before={<Icon name="search-20" className="text-[#B9BDC3]" />}
      className={{
        wrapper: 'h-[46px] rounded-[14px] lg:rounded-[18px]',
        main: 'pl-12 placeholder:text-[#9096A0]',
      }}
    />
  );
}
